import { useEffect, useState } from "react";

import { useLeavesQuery } from "@/graphql/generated";
import { leafLabel } from "@/lib/attributeReview/kindWords";
import { newFieldCheck, searchWord } from "@/lib/attributeReview/newFieldCheck";

export function useNewFieldName(
  ownPath: string | null,
  pickedPath: string | null,
) {
  const cut = ownPath ? ownPath.lastIndexOf(".") + 1 : 0;
  const prefix = ownPath ? ownPath.slice(0, cut) : "";
  const suggested = ownPath ? ownPath.slice(cut) : "";
  const [name, setName] = useState(suggested);
  useEffect(() => setName(suggested), [suggested]);
  const word = searchWord(name);
  const { data } = useLeavesQuery(
    { query: word },
    { enabled: word.length >= 3 },
  );
  const leaves = data?.leaves ?? [];
  const path = prefix + name;
  const check = newFieldCheck(
    path,
    name,
    leaves.map((leaf) => leaf.path),
    pickedPath,
  );
  const like =
    check.state === "similar"
      ? leaves.find((leaf) => leaf.path === check.like)
      : undefined;
  const likeLabel = like ? (like.label ?? leafLabel(like.leaf)) : "";
  return { prefix, name, setName, path, check, likeLabel };
}
